module.exports = __webpack_public_path__ + "img/ercode_pdk.006cff7c.png";